import React from 'react';

export default function StatusBadge({ status }) {
  if (!status) return null;
  return (
    <span className="badge" style={{
      background: status.color + '18',
      color: status.color,
      border: `1px solid ${status.color}30`,
    }}>
      <span style={{
        width: 6, height: 6, borderRadius: '50%',
        background: status.color, flexShrink: 0,
      }} />
      {status.name}
    </span>
  );
}
